import React, { useState, useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, } from 'react-router-dom';
import FabrilifeLandingPage from './components/FabrilifeLandingPage';
import FabrilifeProductList from './components/FabrilifeProductList';
import ProductDetails from './components/ProductDetails';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCart from './components/FloatingCart';
import CheckoutPage from './components/CheckoutPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ParcelTrackingPage from './components/ParcelTrackingPage';
import ProfilePage from './components/ProfilePage';
import LoginPage from './components/LoginPage';
import RefundPolicyPage from './components/RefundPolicyPage';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ContactUsPage';
import FAQPage from './components/FAQPage';
import FavoritesPage from './components/FavoritesPage';
import BottomNavigation from './components/BottomNavigation';
import OrderHistoryPage from './components/OrderHistoryPage';



function App() {
  const [cartItems, setCartItems] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [allProducts, setAllProducts] = useState([]);


  const [orders, setOrders] = useState(() => {
    const savedOrders = localStorage.getItem('userOrders');
    return savedOrders ? JSON.parse(savedOrders) : [];
  });


  const addReviewToOrder = (orderId, productId, rating, comment) => {
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.orderId === orderId
          ? {
            ...order,
            items: order.items.map(item =>
              item.productId === productId
                ? { ...item, review: { rating, comment } }
                : item
            ),
            reviewAdded: true,
          }
          : order
      )
    );
  };



  const addToCart = useCallback((product) => {
    setCartItems(prev => {
      const exists = prev.find(item => item.id === product.id);
      if (exists) {
        return prev.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  }, []);


  // এটা যোগ করো


  useEffect(() => {
    fetch('https://aman-life-style-bd-main-server-974485829900.asia-south1.run.app/products?per_page=1000')
      .then(res => res.json())
      .then(data => setAllProducts(data.products || []));
  }, []);

  const removeFromCart = useCallback((productId) => {
    setCartItems(prev => prev.filter(item => item.id !== productId));
  }, []);

  const updateQuantity = useCallback((productId, quantity) => {
    if (quantity <= 0) { removeFromCart(productId); return; }
    setCartItems(prev =>
      prev.map(item => item.id === productId ? { ...item, quantity } : item)
    );
  }, [removeFromCart]);

  const toggleFavorite = (productId) => {
    setFavorites(prev =>
      prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
    );
  };

  const isFavorite = (productId) => {
    const saved = JSON.parse(localStorage.getItem('favorites') || '[]');
    return saved.some(fav => String(fav.id) === String(productId));
  };

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('authToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }, []);

  const totalCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);


  const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <AuthProvider>
      <BrowserRouter>
        <Header cartCount={totalCount} />

        <div className="App pt-16">
          <Routes>
            <Route path="/" element={<FabrilifeLandingPage />} />
            <Route
              path="/shop"
              element={
                <FabrilifeProductList
                  addToCart={addToCart}
                  toggleFavorite={toggleFavorite}
                  isFavorite={isFavorite}
                  cartItems={cartItems}
                />
              }
            />
            <Route
              path="/product/:id/:titleSlug"
              element={
                <ProductDetails
                  addToCart={addToCart}
                  cartItem={cartItems}
                  toggleFavorite={toggleFavorite}
                  isFavorite={isFavorite}
                  getAuthHeaders={getAuthHeaders}
                />
              }
            />


            <Route path="/track-parcel/:id" element={<ParcelTrackingPage />} />

            {/* যদি শুধু /track-parcel/ থাকে এবং কোনো আইডি না থাকে, তবে এই রুটটি ধরবে */}
            <Route path="/track-parcel/" element={<ParcelTrackingPage />} />

            <Route
              path="/checkout"
              element={
                <CheckoutPage
                  setCart={setCartItems}
                  addOrder={() => { }}
                />
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />


            <Route
              path="/favorites"
              element={
                <FavoritesPage
                  favorites={favorites}
                  allProducts={allProducts}
                  toggleFavorite={toggleFavorite}
                  addToCart={addToCart}
                  cartItems={cartItems}
                />
              }
            />



            <Route path="/faq" element={<FAQPage />} />



            <Route
              path="/contact"
              element={
                < ContactUsPage />
              }
            />


            <Route
              path="/order-history"
              element={<ProtectedRoute><OrderHistoryPage orders={orders} addReviewToOrder={addReviewToOrder} products={allProducts} /></ProtectedRoute>}
            />



            <Route path="/about" element={<AboutUsPage />} />


            <Route path="/refund-policy" element={<RefundPolicyPage />} />

            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </div>

        <Footer />

        <BottomNavigation
          cartItemCount={cartItems.reduce((acc, item) => acc + item.quantity, 0)}
        />
        <FloatingCart
          cartItems={cartItems}
          removeFromCart={removeFromCart}
          updateQuantity={updateQuantity}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;